import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import SimpleMenu from 'components/SimpleMenu';
import { useCallback, useState } from 'react';
import noop from 'lodash/noop';
import {
  DateRangeOptions,
  dateRangeOptionsHash,
  dateRangeOptionsArray,
  StartEndDates,
} from '@constants';

const defaultDateRangeOption = dateRangeOptionsHash[DateRangeOptions.SevenDaysAgo];

const emptyDates = {
  startDate: '',
  endDate: '',
};

const defaultDates = defaultDateRangeOption.formatDates?.() || emptyDates;

export const useDateRangeOptionSelector = () => {
  const { openModal } = useDynamicModal();
  const [selectedDateRangeOption, setSelectedDateRangeOption] = useState(defaultDateRangeOption);
  const [dates, setDates] = useState<{
    startDate: string;
    endDate: string;
  }>(defaultDates);

  const onCustomDateChange = (args: { name: StartEndDates; value: string }) => {
    const { name, value } = args;
    setDates({
      ...dates,
      [name]: value,
    });
  };

  const openDateRangeMenu = useCallback(
    ({
      target,
      onSelect,
    }: {
      target: HTMLElement;
      onSelect?: (args: {
        option: keyof typeof DateRangeOptions;
        startDate: string;
        endDate: string;
      }) => void;
    }) => {
      openModal({
        modal: ({ isOpen: _isOpen, toggle }) => {
          return (
            <SimpleMenu
              anchorEl={target}
              items={dateRangeOptionsArray}
              handleClick={noop}
              handleClose={toggle}
              handleClickV2={({ item }) => {
                if (selectedDateRangeOption === item) {
                  toggle();
                }
                // if is custom
                if (item.value === DateRangeOptions.Custom) {
                  setDates(emptyDates);

                  onSelect?.({ ...emptyDates, option: item.value });
                } else {
                  const dates = item.formatDates?.() || defaultDates;
                  setDates(dates);
                  onSelect?.({ ...dates, option: item.value });
                }

                setSelectedDateRangeOption(item);
              }}
            />
          );
        },
      });
    },
    [openModal, selectedDateRangeOption],
  );

  return {
    openDateRangeMenu,
    selectedDateRangeOption,
    onCustomDateChange,
    dates,
  };
};
